import React, { useState, useEffect } from 'react';
import CoverComponent from 'components/generic-components/CoverComponent';
import ButtonComponent from 'components/generic-components/ButtonComponent';

const covers = {
    cover1: {
        id: 1,
        color: 'red',
        image: null,
    },
    cover2: {
        id: 2,
        color: 'green',
        image: null,
    },
    cover3: {
        id: 3,
        color: '#892222',
        image: null,
    },
    cover5: {
        id: 4,
        color: '#00687E',
        image: null,
    },
    cover5: {
        id: 5,
        name: 'cover-5',
        color: '#586600',
        image: null,
    },
}


const ChooseArtwork = () => {
    const [selected, setSelected] = useState(null);


    useEffect(() => {
        setSelected(Object.values(covers)[0].id)
        return () => {
            setSelected(null)
        }
    }, []);

    return (
        <div className={'d-flex flex-column h-100'}>
            <div className={'d-flex flex-column choose-artwork-container'}>
                {
                    Object.values(covers).map((cover, index) => {
                        return (
                            <CoverComponent
                                key={index}
                                content={cover}
                                setSelected={setSelected}
                                isSelected={selected === cover.id} />
                        )
                    })
                }
            </div>

            <div className="d-flex justify-content-center artwork-save-btn-container">
                <ButtonComponent
                    btnText={'Save'}
                    transparent={false}
                    customClass={'mt-5 mb-5 py-2 px-5 btn-white custom-save-btn artwork-save-btn'}
                />
            </div>
        </div>
    )
}

export default ChooseArtwork;
